import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "cz",
  "use": "cz-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"cz\">\n  <path fill=\"#fff\" d=\"M0 0h512v256H0z\" />\n  <path fill=\"#d7141a\" d=\"M0 256h512v256H0z\" />\n  <path fill=\"#11457e\" d=\"M300 256 0 56v400z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cz.svg
// module id = null
// module chunks = 